import React from "react";
import { Message, toaster } from "rsuite";
import DeliveryDto from "../interfaces/deliveryDto";

const api = process.env.REACT_APP_API_URL ?? "http://localhost:8080";

export const getAllDeliveries = async (
  page: number,
  limit: number,
  query?: string,
  customerFilter?: number,
  sortType?: string,
  sortColumn?: string,
  dateRange?: Array<string>
) => {
  return await fetch(
    `${api}/api/deliveries?page=${page - 1}&size=${limit}${
      query !== "" && query !== undefined ? `&query=${query}` : ""
    }${
      customerFilter !== undefined && customerFilter !== null
        ? `&customerId=${customerFilter}`
        : ""
    }${
      sortType !== undefined &&
      sortType !== null &&
      sortColumn !== undefined &&
      sortColumn !== null
        ? `&sort[${sortColumn}]=${sortType}`
        : ""
    }${
      dateRange !== undefined && dateRange !== null && dateRange.length > 0
        ? `&dateRange=${dateRange}`
        : ""
    }
    `,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
    }
  )
    .then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        throw new Error(`Something went wrong, ${JSON.stringify(res)}`);
      }
    })
    .catch((e) => {
      throw new Error(e);
    });
};

export const getDeliveriesByAnalyse = async (analyseId: number) => {
  return await fetch(`${api}/api/deliveriesByAnalyse/${analyseId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${localStorage.getItem("accessToken")}`,
    },
  }).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      throw new Error(`Something went wrong, ${JSON.stringify(res)}`);
    }
  });
};

export const createDelivery = async (body: DeliveryDto) => {
  return await fetch(`${api}/api/deliveries/createDelivery`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": `${localStorage.getItem("accessToken")}`,
    },
    body: JSON.stringify(body),
  })
    .then(async (res) => {
      if (res.ok) {
        const data = await res.json();
        toaster.push(
          <Message showIcon type='success' header='Erfolgreich'>
            Der Artikel {data.name} wurde erfolgreich gespeichert.
          </Message>
        );
      }
    })
    .catch((e) => {
      console.log(e);
      toaster.push(
        <Message showIcon type='error' header='Fehlgeschlagen'>
          Leider ist beim Speichern des Artikels etwas schiefgelaufen.
        </Message>
      );
      return;
    });
};

export const updateDelivery = async (id: number, body: DeliveryDto) => {
  try {
    const delivery = await fetch(`${api}/api/deliveries/${id}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
      body: JSON.stringify(body),
    });

    if (delivery.ok) {
      const data = await delivery.json();
      toaster.push(
        <Message showIcon type='success' header='Erfolgreich'>
          Der User {data.name} wurde erfolgreich gespeichert.
        </Message>
      );
    }
  } catch (e) {
    console.log(e);
    toaster.push(
      <Message showIcon type='error' header='Fehlgeschlagen'>
        Leider ist beim Speichern des Users etwas schiefgelaufen.
      </Message>
    );
    return;
  }
};

export const deleteDelivery = async (id: number) => {
  try {
    const deleteDelivery = await fetch(`${api}/api/deliveries/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": `${localStorage.getItem("accessToken")}`,
      },
    });
    if (deleteDelivery.ok) {
      const data = await deleteDelivery.json();
      toaster.push(
        <Message showIcon type='success' header='Erfolgreich'>
          Der Delivery {data.name} wurde erfolgreich gelöscht.
        </Message>
      );
    }
  } catch (e) {
    console.log(e);
    toaster.push(
      <Message showIcon type='error' header='Fehlgeschlagen'>
        Leider ist beim Löschen des Deliveries etwas schiefgelaufen.
      </Message>
    );
    return;
  }
};
